<template>
    <el-dialog
        title="司机信息"
        top="8%"
        width="30%"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        class="assign-driver-dialog"
    >
        <el-form
            :model="assignDriverInfoData"
            :rules="rules"
            ref="form"
            label-width="120px"
        >

            <el-row>
                <el-col :span="22">
                    <el-form-item label="手机号：" prop="driverMobile">
                        <el-input v-model="assignDriverInfoData.driverMobile" autocomplete="off" placeholder="司机电话" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="姓名：" prop="driverName">
                        <el-input v-model="assignDriverInfoData.driverName" autocomplete="off" placeholder="司机名称" clearable maxlength="32"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="车牌号：" prop="carNo">
                        <el-input v-model="assignDriverInfoData.carNo" autocomplete="off" placeholder="车牌号码" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <template #footer class="dialog-footer">
            <el-button type="primary" @click="handleSubmit">提 交</el-button>
            <el-button @click="handleClose">取 消</el-button>
        </template>

    </el-dialog>
</template>

<script>
import { transferOrderOrAssignDriver } from '../../../../../api/transferSystem.js';
export default {
    name: 'assignDriverDialog',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Array | Object,
            required: true
        },
        batchFlag: {
            type: Boolean,
            default: false
        }
    },
    data () {
        // 校验 司机手机号 格式
        var validateDriverPass = (rule, value, callback) => {
            const _phoneVerify = /^1(3|4|5|6|7|8|9)\d{9}$/;
            if (!value) {
                callback(new Error('请输入司机手机号'));
            } else if(!_phoneVerify.test(value)) {
                callback(new Error('请输入正确的司机手机号'));
            } else {
                callback();
            }
        };

        // 校验 车牌号 格式
        var validateCarNoPass = (rule, value,callback) => {
            const _carNoVerify = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/;
            if (!value) {
                callback(new Error('请输入车牌号码'));
            } else if(!_carNoVerify.test(value)) {
                callback(new Error('请输入正确的车牌号码'));
            } else {
                callback();
            }
        };
        return {
            assignDriverInfoData: {
                carNo:'',
                driverName:'',
                driverMobile: ''
            },
            rules:{
                driverName: [{ required: true, message: '请输入司机姓名', trigger: ['change', 'blur'] }],
                driverMobile: [{ validator: validateDriverPass, required: true, trigger: ['change', 'blur'] }],
                carNo: [{ validator: validateCarNoPass, required: true, trigger: ['change', 'blur'] }]
            }
        }
    },
    methods: {
        // 提交
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 判断是否为 批量操作
                    if (!this.batchFlag) {
                        const param = this.formateSingleSubmitParams();
                        this.submitByApi([param]);
                    } else {
                        const param = this.formateBatchSubmitParams(this.rowData);
                        this.submitByApi(param);
                    }
                } else {
                    return false;
                }
            });
        },
        // 行操作 货站转单 提交时 组装数据
        formateSingleSubmitParams () {
            const data = {
                ...this.rowData,
                carNo: this.assignDriverInfoData.carNo,
                driverName: this.assignDriverInfoData.driverName,
                driverMobile: this.assignDriverInfoData.driverMobile,
            }
            return data;
        },
        // 批量货站转单 提交时 遍历 并组装参数
        formateBatchSubmitParams (list) {
            list.forEach(item => {
                item.carNo = this.assignDriverInfoData.carNo,
                item.driverName = this.assignDriverInfoData.driverName,
                item.driverMobile = this.assignDriverInfoData.driverMobile
            });
            return list;
        },
        // 提交按钮 调用接口
        submitByApi (params) {
            transferOrderOrAssignDriver(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.$emit('handleSuccess','assignDriverDialog')
                })
        },
        // 关闭弹窗
        handleClose () {
            this.$emit('handleClose', 'assignDriverDialog');
        }
    }
}
</script>
<style lang="less" scoped>
.assign-driver-dialog {
    .el-dialog__body {
        margin-top: 10px;
    }
    .el-col {
        width: 98%;
    }
}
</style>
